'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _roles = require('config/permissions/roles');

var _categories = require('./categories/categories.module');

var _categories2 = _interopRequireDefault(_categories);

var _companies = require('./companies/companies.module');

var _companies2 = _interopRequireDefault(_companies);

var _company = require('./company/company.module');

var _company2 = _interopRequireDefault(_company);

var _mapCategories = require('./map-categories/map-categories.module');

var _mapCategories2 = _interopRequireDefault(_mapCategories);

var _mapIngredients = require('./map-ingredients/map-ingredients.module');

var _mapIngredients2 = _interopRequireDefault(_mapIngredients);

var _memberCompliance = require('./member-compliance/member-compliance.module');

var _memberCompliance2 = _interopRequireDefault(_memberCompliance);

var _memberComplianceProcess = require('./member-compliance/member-compliance-process.module');

var _memberComplianceProcess2 = _interopRequireDefault(_memberComplianceProcess);

var _regulator = require('./regulator/regulator.module');

var _regulator2 = _interopRequireDefault(_regulator);

var _userIngredients = require('./user-ingredients/user-ingredients.module');

var _userIngredients2 = _interopRequireDefault(_userIngredients);

var _systemIngredients = require('./system-ingredients/system-ingredients.module');

var _systemIngredients2 = _interopRequireDefault(_systemIngredients);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.app.admin', [_angularUiRouter2.default, _categories2.default, _companies2.default, _company2.default, _mapCategories2.default, _mapIngredients2.default, _memberCompliance2.default, _memberComplianceProcess2.default, _regulator2.default, _userIngredients2.default, _systemIngredients2.default]).config(function ($stateProvider) {
  'ngInject';

  $stateProvider.state('admin', {
    parent: 'app',
    template: '<ui-view flex layout="column"></ui-view>',
    url: '/admin',
    data: {
      permissions: {
        only: [_roles.SYS_ADMIN],
        redirectTo: 'dashboard'
      }
    }
  });
}).name;


// WEBPACK FOOTER //
// ./components/app/admin/admin.module.js